// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1ci%n%+e$%7Rj9oc4:Qe:(N)[>_,G!>R<Vo)y6n!R%NS_6o<y9L!o(j4Q3iro3LtJVN,-7pFe!H,V2_RFI_yQ9yt;I_%yc+Ve2YVopR+QVyd_97,YVeQ8IL+>,naa2<+;IiaKpQVR%bR3c<!7,Q-yp%eY(H949pFH3et3ciSfpLaB%i!v3RQmk%dEaQdvp<4Fp<rBIg<B6bX;2%r<I7y@6gR<pL4!I<4Q>%X<2p@@!Q462b-v2%d)I<-@aQd@pg@@!Q4@2_@F!Qd:Ip!@I<4)aKz<I_y6IbX<!Q-Qp<-F>Q4:>Q8vIbR)9jz;!jL;9jyFI7yFI7yFI9ll';
